<template>
  <div>
    <CashoutsComponent />
  </div>
</template>

<script>
import CashoutsComponent from './components/Index.vue'

export default {
  name: 'Cashouts',
  components: {
    CashoutsComponent,
  }
}
</script>
